import { useMutation } from "@tanstack/react-query"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useDeleteOpChainMutation = () =>
  useMutation({
    mutationFn: async (id: string) => {
      const res = await httpClient.delete(`/admin/op-chain/${id}`)
      return res.data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["findAllOpChain"],
      })
      showSuccessNotification({
        title: "Success",
        message: "Operation chain deleted",
      })
    },
    onError: (error) => {
      showAxiosError({
        notificationTitle: "Error",
        notificationMessage: "Failed to delete operation chain",
        showNotification: true,
        error,
      })
    },
  })
